import React, { Component } from "react";
import { connect } from "react-redux";

import { getUsers, updateUsersStatus } from "../../store/user";
import { setCurrentChannel } from "../../store/channels";
import userService from "../../services/userService";

import { Icon, Menu, Loader, Image } from "semantic-ui-react";

class DirectMessages extends Component {
    state = { currentUser: null };

    async componentDidMount() {
        await this.props.getUsers();

        const { user: { currentUser, users } = {}, updateUsersStatus } = this.props;

        userService.setConnectionInfoListener(snap => {
            if (!snap.val() || !currentUser?.uid) return;

            const currentUserPresenceRef = userService.presenceRef.child(currentUser?.uid);

            currentUserPresenceRef.set(true);

            currentUserPresenceRef.onDisconnect().remove();
        });

        userService.setPresenceListener("child_added", snap => {
            currentUser?.uid !== snap.key && updateUsersStatus(userService.updateUsersStatus(users, snap.key));
        });

        userService.setPresenceListener("child_removed", snap => {
            currentUser?.uid !== snap.key && updateUsersStatus(userService.updateUsersStatus(users, snap.key, false));
        });

        this.setState({ currentUser });
    }

    componentWillUnmount() {
        this.state.currentUser && userService.presenceRef.child(this.state.currentUser?.uid).remove();

        userService.presenceRef.off();
    }

    async changeActiveChannel(user) {
        const { user: { currentUser } = {}, setCurrentChannel } = this.props;

        let channelId = user.id < currentUser?.uid ? `${user.id}/${currentUser?.uid}` : `${currentUser?.uid}/${user.id}`;

        setCurrentChannel({
            id: channelId,
            channelName: user.name,
            channelDetails: "private channel",
            isPrivateChannel: true,
        });

        this.props.setActiveChannel(user.id);
    }

    renderUser = user => (
        <Menu.Item
            key={user.id}
            name={user.name}
            className="user-item"
            active={this.props.activeChannel.split("/")[0] === user.id}
            onClick={() => this.changeActiveChannel(user)}>
            <Icon name="circle" color={user?.status === "online" ? "green" : "red"} />
            <Image src={user?.avatar} spaced="right" avatar /> @ {user.name}
        </Menu.Item>
    );

    render() {
        const { user } = this.props;

        return (
            <Menu.Menu>
                <Menu.Item>
                    <span>
                        <Icon name="mail" /> DIRECT MESSAGES
                    </span>
                    ({user.users.length})
                </Menu.Item>

                {user.loading ? (
                    <Loader active inline="centered" inverted content="Loading" style={{ marginTop: 22 }} />
                ) : (
                    user.users.map(this.renderUser)
                )}
            </Menu.Menu>
        );
    }
}

export default connect(({ user }) => ({ user }), { getUsers, updateUsersStatus, setCurrentChannel })(DirectMessages);
